import styled from 'styled-components'

function BaseCopyIcon({ className, size = 20 }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
    >
      <path
        fill="currentColor"
        d="M15.75 6.705a1 1 0 0 0-.045-.202v-.068a.8.8 0 0 0-.143-.21l-4.5-4.5a.8.8 0 0 0-.21-.143.2.2 0 0 0-.067 0 .7.7 0 0 0-.248-.082H7.5a2.25 2.25 0 0 0-2.25 2.25v.75H4.5a2.25 2.25 0 0 0-2.25 2.25v7.5A2.25 2.25 0 0 0 4.5 16.5h6a2.25 2.25 0 0 0 2.25-2.25v-.75h.75a2.25 2.25 0 0 0 2.25-2.25V6.705m-4.5-2.647L13.193 6H12a.75.75 0 0 1-.75-.75zm0 10.192a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75v-7.5A.75.75 0 0 1 4.5 6h.75v5.25A2.25 2.25 0 0 0 7.5 13.5h3.75zm3-3a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75v-7.5A.75.75 0 0 1 7.5 3h2.25v2.25A2.25 2.25 0 0 0 12 7.5h2.25z"
      />
    </svg>
  )
}

export const CopyIcon = styled(BaseCopyIcon)``
